import React from 'react';
import { preventMouseMove } from '../../../helpers/events';
import ActionButton from '../ActionButton';
import ZoomStyles from '../../../shared/components/Zoom/styles';
import useZoom from '../../../hooks/useZoom';

const Zoom = ({ toggleFullscreen, isFullscreen, withoutFullscreen, hideZoom }) => {
  const { isMobile, zoomState, zoomIn, zoomOut, basketSize } = useZoom();
  const { zoomIsMaximum, zoomIsMinimum } = zoomState;

  return (
    <div>
      {!hideZoom && (
        <ZoomStyles.Container isFullscreen={isFullscreen} offset={basketSize}>
          <ActionButton onMouseMove={preventMouseMove} disabled={zoomIsMaximum} onClick={zoomIn}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 5V19"
                stroke="#636363"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 12H19"
                stroke="#636363"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ActionButton>
          <ActionButton
            data-cyid="zoomOutBtn"
            onMouseMove={preventMouseMove}
            disabled={zoomIsMinimum}
            onClick={zoomOut}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19"
                stroke="#636363"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </ActionButton>
        </ZoomStyles.Container>
      )}
      {!isMobile && !withoutFullscreen && (
        <ZoomStyles.Fullscreen offset={basketSize}>
          <ActionButton onMouseMove={preventMouseMove} onClick={toggleFullscreen}>
            {isFullscreen ? (
              <svg
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.64"
                  d="M5.46875 8.625C5.63281 8.625 5.79688 8.70703 5.93359 8.81641C6.04297 8.95312 6.125 9.11719 6.125 9.28125V12.3438C6.125 12.5352 6.04297 12.6992 5.93359 12.8086C5.79688 12.9453 5.63281 13 5.46875 13C5.27734 13 5.11328 12.9453 5.00391 12.8086L4.15625 11.9062L1.44922 14.6133C1.33984 14.7227 1.23047 14.75 1.12109 14.75C1.01172 14.75 0.902344 14.7227 0.820312 14.6133L0.136719 13.9297C0.0273438 13.8477 0 13.7383 0 13.6289C0 13.5195 0.0273438 13.4102 0.136719 13.3008L2.84375 10.5938L1.94141 9.74609C1.80469 9.63672 1.75 9.47266 1.75 9.28125C1.75 9.11719 1.80469 8.95312 1.94141 8.81641C2.05078 8.70703 2.21484 8.625 2.40625 8.625H5.46875ZM8.53125 6.875C8.33984 6.875 8.17578 6.82031 8.06641 6.68359C7.92969 6.57422 7.875 6.41016 7.875 6.21875V3.15625C7.875 2.99219 7.92969 2.82812 8.06641 2.69141C8.17578 2.58203 8.33984 2.5 8.53125 2.5C8.69531 2.5 8.85938 2.58203 8.99609 2.69141L9.84375 3.59375L12.5508 0.886719C12.6328 0.804688 12.7422 0.75 12.8516 0.75C12.9609 0.75 13.0703 0.804688 13.1797 0.886719L13.8633 1.57031C13.9453 1.67969 14 1.78906 14 1.89844C14 2.00781 13.9453 2.11719 13.8633 2.19922L11.1562 4.90625L12.0586 5.75391C12.168 5.89062 12.25 6.05469 12.25 6.21875C12.25 6.41016 12.168 6.57422 12.0586 6.68359C11.9219 6.82031 11.7578 6.875 11.5938 6.875H8.53125ZM11.1562 10.5938L13.8633 13.3008C13.9453 13.4102 14 13.5195 14 13.6289C14 13.7383 13.9453 13.8477 13.8633 13.9297L13.1797 14.6133C13.0703 14.7227 12.9609 14.75 12.8516 14.75C12.7422 14.75 12.6328 14.7227 12.5508 14.6133L9.84375 11.9062L8.99609 12.8086C8.85938 12.9453 8.69531 13 8.53125 13C8.33984 13 8.17578 12.9453 8.06641 12.8086C7.92969 12.6992 7.875 12.5352 7.875 12.3438V9.28125C7.875 9.11719 7.92969 8.95312 8.06641 8.81641C8.17578 8.70703 8.33984 8.625 8.53125 8.625H11.5938C11.7578 8.625 11.9219 8.70703 12.0586 8.81641C12.168 8.95312 12.25 9.11719 12.25 9.28125C12.25 9.47266 12.168 9.63672 12.0586 9.74609L11.1562 10.5938ZM5.00391 2.69141C5.11328 2.58203 5.27734 2.5 5.46875 2.5C5.63281 2.5 5.79688 2.58203 5.93359 2.69141C6.04297 2.82812 6.125 2.99219 6.125 3.15625V6.21875C6.125 6.41016 6.04297 6.57422 5.93359 6.68359C5.79688 6.82031 5.63281 6.875 5.46875 6.875H2.40625C2.21484 6.875 2.05078 6.82031 1.94141 6.68359C1.80469 6.57422 1.75 6.41016 1.75 6.21875C1.75 6.05469 1.80469 5.89062 1.94141 5.75391L2.84375 4.90625L0.136719 2.19922C0.0273438 2.11719 0 2.00781 0 1.89844C0 1.78906 0.0273438 1.67969 0.136719 1.57031L0.820312 0.886719C0.902344 0.804688 1.01172 0.75 1.12109 0.75C1.23047 0.75 1.33984 0.804688 1.44922 0.886719L4.15625 3.59375L5.00391 2.69141Z"
                  fill="black"
                />
              </svg>
            ) : (
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  opacity="0.64"
                  d="M0.375 4.67188C0.375 4.78125 0.402344 4.86328 0.457031 4.91797C0.511719 4.97266 0.59375 5 0.703125 5H1.79688C1.87891 5 1.96094 4.97266 2.01562 4.91797C2.07031 4.86328 2.125 4.78125 2.125 4.67188V2.375H4.42188C4.50391 2.375 4.58594 2.34766 4.64062 2.29297C4.69531 2.23828 4.75 2.15625 4.75 2.04688V0.953125C4.75 0.871094 4.69531 0.789062 4.64062 0.734375C4.58594 0.679688 4.50391 0.625 4.42188 0.625H1.03125C0.839844 0.625 0.675781 0.707031 0.566406 0.816406C0.429688 0.953125 0.375 1.11719 0.375 1.28125V4.67188ZM8.25 0.953125C8.25 0.871094 8.27734 0.789062 8.33203 0.734375C8.38672 0.679688 8.46875 0.625 8.57812 0.625H11.9688C12.1328 0.625 12.2969 0.707031 12.4336 0.816406C12.543 0.953125 12.625 1.11719 12.625 1.28125V4.67188C12.625 4.78125 12.5703 4.86328 12.5156 4.91797C12.4609 4.97266 12.3789 5 12.2969 5H11.2031C11.0938 5 11.0117 4.97266 10.957 4.91797C10.9023 4.86328 10.875 4.78125 10.875 4.67188V2.375H8.57812C8.46875 2.375 8.38672 2.34766 8.33203 2.29297C8.27734 2.23828 8.25 2.15625 8.25 2.04688V0.953125ZM12.2969 8.5C12.3789 8.5 12.4609 8.55469 12.5156 8.60938C12.5703 8.66406 12.625 8.74609 12.625 8.82812V12.2188C12.625 12.4102 12.543 12.5742 12.4336 12.6836C12.2969 12.8203 12.1328 12.875 11.9688 12.875H8.57812C8.46875 12.875 8.38672 12.8477 8.33203 12.793C8.27734 12.7383 8.25 12.6562 8.25 12.5469V11.4531C8.25 11.3711 8.27734 11.2891 8.33203 11.2344C8.38672 11.1797 8.46875 11.125 8.57812 11.125H10.875V8.82812C10.875 8.74609 10.9023 8.66406 10.957 8.60938C11.0117 8.55469 11.0938 8.5 11.2031 8.5H12.2969ZM4.75 12.5469C4.75 12.6562 4.69531 12.7383 4.64062 12.793C4.58594 12.8477 4.50391 12.875 4.42188 12.875H1.03125C0.839844 12.875 0.675781 12.8203 0.566406 12.6836C0.429688 12.5742 0.375 12.4102 0.375 12.2188V8.82812C0.375 8.74609 0.402344 8.66406 0.457031 8.60938C0.511719 8.55469 0.59375 8.5 0.703125 8.5H1.79688C1.87891 8.5 1.96094 8.55469 2.01562 8.60938C2.07031 8.66406 2.125 8.74609 2.125 8.82812V11.125H4.42188C4.50391 11.125 4.58594 11.1797 4.64062 11.2344C4.69531 11.2891 4.75 11.3711 4.75 11.4531V12.5469Z"
                  fill="black"
                />
              </svg>
            )}
          </ActionButton>
        </ZoomStyles.Fullscreen>
      )}
    </div>
  );
};

export default Zoom;
